import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Select } from "antd";
import Swal from "sweetalert2";
import "../../Config/swal.css";

export default function EditProduct({ productObj }) {
  const [taxOptionsData, setTaxOptionsData] = useState([]);
  const [selectedTxId, setSelectedTaxId] = useState("");
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    id: "",
    size: "",
    name: "",
    mm: "",
    inches: "",
    weight: "",
  });

  console.log(productObj);
  useEffect(() => {
    if (productObj) {
      setFormValues({
        id: productObj?.id || "",
        size: productObj?.size || "",
        name: productObj?.name || "",
        mm: productObj?.mm || "",
        inches: productObj?.inches || "",
        weight: productObj?.weight || "",
      });

      setSelectedTaxId(productObj?.taxid || "");
    } else {
      console.error("No product data found");
    }
  }, [productObj]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const response = await fetch(`${API_BASE_CRM_URL}GetTaxes`);
        if (!response.ok) {
          throw new Error("Failed to fetch taxes");
        }
        const data = await response.json();

        if (data.Status && Array.isArray(data.ResultData)) {
          setTaxOptionsData(data.ResultData);
        } else {
          console.error("Invalid tax data format:", data);
        }
      } catch (error) {
        console.error("Error fetching tax data:", error);
      }
    };

    fetchTaxes();
  }, []);

  const taxOptions = taxOptionsData.map((item) => ({
    value: item.id,
    label: `${item.name} - ${item.taxrate}%`,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...formValues,
      taxid: Number(selectedTxId),
    };

    try {
      const response = await fetch(`${API_BASE_CRM_URL}UpdateProduct`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Update response:", result);

      if (result.status === true || response.ok) {
        Swal.fire({
          title: "Product Updated Successfully",
          icon: "success",
        }).then(() => window.location.reload());
      } else {
        throw new Error(result.message || "Failed to update product.");
      }
    } catch (error) {
      console.error("Error updating product:", error);
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end custom-offcanvas"
      tabIndex="-1"
      id="offcanvasEdit"
      aria-labelledby="offcanvasRightLabel"
    >
      <style>
        {`
                .offcanvas.custom-offcanvas {
                    width: 450px !important; /* Adjust this as needed */
                }

                @media (max-width: 576px) {
                    .offcanvas.custom-offcanvas {
                    width: 70% !important; /* Adjust the percentage as needed */
                    }
                }
                `}
      </style>
      <div className="offcanvas-header">
        <div className="page-title d-flex justify-content-between align-items-center">
          <h4>Edit Product Details</h4>
          {productObj?.status === 1 ? (
            <span className="badge bg-outline-success ms-2">Active</span>
          ) : (
            <span className="badge bg-outline-danger ms-2">Inactive</span>
          )}
        </div>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <hr />
      <div className="offcanvas-body ms-2">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="mb-3 col-12">
              <label className="form-label">Size</label>
              <input
                type="text"
                name="size"
                className="form-control"
                placeholder="Enter Size"
                value={formValues.size}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Enter name"
                value={formValues.name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Tax</label>
              <select
                className="form-control"
                value={selectedTxId}
                onChange={(e) => setSelectedTaxId(e.target.value)}
              >
                <option value="">Select Tax</option>
                {taxOptions.map((tax) => (
                  <option key={tax.value} value={tax.value}>
                    {tax.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Size in mm</label>
              <input
                type="text"
                className="form-control"
                name="mm"
                placeholder="Enter mm"
                value={formValues.mm}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Size in Inches</label>
              <input
                type="text"
                className="form-control"
                name="inches"
                placeholder="Enter inches"
                value={formValues.inches}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Weight</label>
              <input
                type="text"
                className="form-control"
                name="weight"
                placeholder="Enter weight"
                value={formValues.weight}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="col-12 mt-3 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="offcanvas"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary ms-2"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

EditProduct.propTypes = {
  productObj: PropTypes.array.isRequired,
};
